export const message = {
  officialAnswer: "공식 응답",
  answerCheckedMessage: "답변이 성공적으로 확인되었습니다",
  setOfficialAnswerContent: "이것을 공식 응답으로 지정하시겠습니까?",
};
